import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryGrid() {
  const displayCategories = categories.filter((c) => c.id !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3 font-heading">
            浏览视频分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            多种影视类型随心选择，总有你喜欢的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {displayCategories.map((category) => (
            <Link
              key={category.id}
              to={`/category?type=${category.id}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-background-100 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${category.icon} text-xl md:text-2xl text-foreground-600 group-hover:text-primary-500 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
                {category.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}